import { TranslationsContext } from '@telia-common-components/shared';
import * as React from 'react';
import { Notice, Separator } from 'telia-front-react';
import { useInternetCalculator } from '../InternetCalculatorProvider';
export const NoResultsNotice = (props) => {
    const { translate } = React.useContext(TranslationsContext);
    const { isSecureNet } = useInternetCalculator();
    const labelKeySuffix = props.isError ? 'error' : 'attention';
    const labelKey = `${isSecureNet ? 'secureNetCalculator.noResults.' : 'internetCalculator.noResults.'}${labelKeySuffix}`;
    return (React.createElement(React.Fragment, null,
        React.createElement(Separator, { spacing: "xsmall", color: "invisible" }),
        React.createElement(Notice, { type: props.isError ? 'error' : 'attention' }, translate(labelKey)),
        React.createElement(Separator, { spacing: "xsmall", color: "invisible" })));
};
